import {NavLink} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

import {moduleConfig} from '../config';

export const DetailPageNavigation = ({title}: { title: string }) => {
    const breadcrumbs = [
        {title: I18n.get('Home'), href: '/dashboard'},
        {title: I18n.get(moduleConfig.titles.plural), href: moduleConfig.basePath},
        {title},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
